import firebase from '@/firebase/config'
import 'firebase/auth'

const auth = firebase.auth()

if (window.location.hostname === 'localhost' && process.env.VUE_APP_USE_EMULATOR === 'true') {
    auth.useEmulator('http://localhost:9099')
}

export default auth
